import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getDoctoralCommitteeProofsByOwnerOptions } from '@/module/Author/DoctoralCommittee/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface DoctoralCommitteeOwnerProofListProps {
  doctoralCommitteeId: Id;
  userId: Id;
}

export function DoctoralCommitteeOwnerProofList({ doctoralCommitteeId, userId }: DoctoralCommitteeOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getDoctoralCommitteeProofsByOwnerOptions(doctoralCommitteeId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="doctoral-committee"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
